import { useState, useCallback, type ReactNode } from 'react';
import { I18nContext, t as translate, type Locale } from '@/lib/i18n';

const LOCALE_KEY = 'mfc-locale';

function getInitialLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_KEY);
  if (stored === 'ko' || stored === 'en' || stored === 'ja') return stored;
  const browserLang = navigator.language.slice(0, 2);
  if (browserLang === 'ko' || browserLang === 'ja') return browserLang;
  return 'en';
}

export function I18nProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(getInitialLocale);

  const setLocale = useCallback((l: Locale) => {
    setLocaleState(l);
    localStorage.setItem(LOCALE_KEY, l);
  }, []);

  const t = useCallback(
    (key: string, params?: Record<string, string>) => translate(key, locale, params),
    [locale]
  );

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}
